<template>
  <component
    :is="this.$route.meta.layout || 'div'"
    :key="'comp_' + (this.$route.meta.layout || 'div')"
  >
    <!-- <component :is="layout"> -->
    <transition name="page" mode="out-in" appear>
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <!-- <vue-splash
      :show="splashShow"
      :logo="logo"
      title=""
      color="#fff"
      :size="300"
      :fixed="true"
    /> -->
  </component>
</template>

<script>
import { Header, Navbar, LeftSidebar, Footer } from "@/components/partials";
import image from "./assets/logo.svg";
export default {
  name: "App",
  components: {
    Header,
    Navbar,
    LeftSidebar,
    Footer,
  },
  computed: {
    logo() {
      return image;
    },
  },
  data: () => ({
    // layout: "div",
    splashShow: true,
  }),
  mounted: function () {
    //console.log('App component mounted.');
    // setTimeout(() => {
    //   this.splashShow = false;
    // }, 1000);
    /*if (window.$("#loading__container").is(":visible")) {
      window.$("#loading__container").fadeOut(1000, "swing", () => {
        console.log("Fadeout Complete!!");
      });
    }*/
	window.$(".loader").fadeOut(1000, "swing", () => {
		console.log("Fadeout Complete!!");
	});
  },
  created() {
    //
    // this.splashShow = false;
    // window.$("#loading__container").show();
  },
};
</script>

<style lang="scss">
.page-enter-active,
.page-leave-active {
  transition: opacity 0.5s ease, transform 0.5s;
  // transition: opacity 2.5s ease, transform 0.5s;
}
.page-leave-to {
  opacity: 0;
  transform: translateX(-1%);
}
.page-enter {
  opacity: 0;
  transform: translateX(1%);
}
.notifications.vue-notifyjs {
  .notification-list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .notification-list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .notification-list-enter-active,
  .notification-list-leave-active {
    transition: opacity 0.4s;
  }
  .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */ {
    opacity: 0;
  }
}
</style>
